import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.mapeamento
    ? _c(
        VForm,
        {
          ref: "form",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.onSubmit.apply(null, arguments)
            },
          },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c(
            VRow,
            { attrs: { "no-gutters": "" } },
            [
              _c(
                VCol,
                { attrs: { cols: "12" } },
                [_c("app-title", { attrs: { texto: _vm.titulo } })],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            [
              (_vm.mapeamento.mapeamentoImportado &&
                _vm.mapeamento.tipoImportacaoMapeamento) ||
              !_vm.isEdicaoBloqueada
                ? _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        VCard,
                        { attrs: { flat: "", outlined: "" } },
                        [
                          _c(
                            VCardTitle,
                            { staticClass: "subtitle-1 primary--text" },
                            [_vm._v(" Importar Mapeamento ")]
                          ),
                          _c(
                            VCardText,
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "12" } },
                                    [
                                      _vm.mapeamento.mapeamentoImportado &&
                                      _vm.mapeamento.tipoImportacaoMapeamento
                                        ? _c(
                                            VChip,
                                            {
                                              attrs: {
                                                color: "success",
                                                "text-color": "white",
                                                close: !_vm.isEdicaoBloqueada,
                                              },
                                              on: {
                                                "click:close":
                                                  _vm.removeImportacao,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.mapeamento
                                                      .mapeamentoImportado.nome
                                                  ) +
                                                  " - " +
                                                  _vm._s(
                                                    _vm.mapeamento
                                                      .tipoImportacaoMapeamento
                                                      .nome
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : !_vm.isEdicaoBloqueada
                                        ? _c(
                                            VTooltip,
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        _c(
                                                          VBtn,
                                                          _vm._g(
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "primary",
                                                                dark: "",
                                                                text: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.toogleDialogImportacao,
                                                              },
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              " Adicionar "
                                                            ),
                                                            _c(
                                                              VIcon,
                                                              {
                                                                staticClass:
                                                                  "ml-2",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " add_circle "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                1411404915
                                              ),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "Clique para adicionar um mapeamento"
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                VCol,
                { attrs: { cols: "12" } },
                [
                  _c(
                    VCard,
                    { attrs: { flat: "", outlined: "" } },
                    [
                      _c(
                        VCardTitle,
                        { staticClass: "subtitle-1 primary--text" },
                        [_vm._v(" Unidade Principal ")]
                      ),
                      _c(
                        VCardText,
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(VAutocomplete, {
                                    attrs: {
                                      items: _vm.unidadesOrdenadasPorSigla,
                                      "item-text": _vm.getUnidadeSiglaAndNome,
                                      label: "Unidade principal",
                                      placeholder: "Digite para pesquisar...",
                                      rules: [
                                        (v) => !!v || "Selecione a unidade",
                                      ],
                                      disabled:
                                        _vm.isEdicaoBloqueada ||
                                        _vm.mapeamento.mapeamentoImportado !==
                                          null,
                                      "prepend-icon": "search",
                                      "auto-select-first": "",
                                      clearable: "",
                                      chips: "",
                                      "deletable-chips": "",
                                      "return-object": "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "selection",
                                          fn: function (data) {
                                            return [
                                              _c(
                                                VChip,
                                                {
                                                  staticClass:
                                                    "chip--select-multi",
                                                  attrs: {
                                                    color: "primary",
                                                    "text-color": "white",
                                                    close:
                                                      !_vm.isEdicaoBloqueada &&
                                                      _vm.mapeamento
                                                        .mapeamentoImportado ===
                                                        null,
                                                  },
                                                  on: {
                                                    "click:close": function (
                                                      $event
                                                    ) {
                                                      _vm.mapeamento.unidade =
                                                        null
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        `${data.item.sigla} - ${data.item.nome}`
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1725245737
                                    ),
                                    model: {
                                      value: _vm.mapeamento.unidade,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.mapeamento, "unidade", $$v)
                                      },
                                      expression: "mapeamento.unidade",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "12" } },
                [
                  _c(
                    VCard,
                    {
                      staticClass: "overflow-y-auto",
                      attrs: { "max-height": "400", flat: "", outlined: "" },
                    },
                    [
                      _c(
                        VCardTitle,
                        { staticClass: "subtitle-1 primary--text" },
                        [
                          _vm._v(
                            " Unidades Vinculadas (" +
                              _vm._s(_vm.mapeamento.unidades.length) +
                              " selecionada(s)) "
                          ),
                        ]
                      ),
                      _vm.mapeamento.unidade &&
                      _vm.mapeamento.unidades.length === 0
                        ? _c(VCardSubtitle, [
                            _vm._v(
                              " Selecione ao menos uma unidade vinculada "
                            ),
                          ])
                        : _vm._e(),
                      _c(
                        VCardText,
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on: onTooltip }) {
                                              return [
                                                _c(
                                                  VCheckbox,
                                                  _vm._g(
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.subunidades
                                                              .length > 0,
                                                          expression:
                                                            "subunidades.length > 0",
                                                        },
                                                      ],
                                                      staticClass: "ml-4",
                                                      attrs: {
                                                        disabled:
                                                          _vm.isEdicaoBloqueada,
                                                        label:
                                                          "Selecionar Todas",
                                                        color: "secondary",
                                                      },
                                                      on: {
                                                        change: _vm.toggleItens,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.selectAllItens,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.selectAllItens =
                                                            $$v
                                                        },
                                                        expression:
                                                          "selectAllItens",
                                                      },
                                                    },
                                                    { ...onTooltip }
                                                  )
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3000250810
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Clique para selecionar todas as unidades vinculadas"
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(VTreeview, {
                                    attrs: {
                                      items: _vm.unidadesTreeview,
                                      "selection-type": "independent",
                                      "selected-color": "secondary",
                                      "item-disabled": "bloqueado",
                                      dense: "",
                                      "open-all": "",
                                      selectable: "",
                                      "open-on-click": "",
                                      "return-object": "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function ({ item }) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    `${item.sigla} - ${item.nome}`
                                                  ) +
                                                  " "
                                              ),
                                              item.importado
                                                ? _c(
                                                    VChip,
                                                    {
                                                      staticClass: "ml-2",
                                                      attrs: {
                                                        color: "success",
                                                        outlined: "",
                                                        small: "",
                                                      },
                                                    },
                                                    [_vm._v(" Mapeada ")]
                                                  )
                                                : _vm._e(),
                                              _c(VSpacer),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3461402178
                                    ),
                                    model: {
                                      value: _vm.mapeamento.unidades,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.mapeamento,
                                          "unidades",
                                          $$v
                                        )
                                      },
                                      expression: "mapeamento.unidades",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "12", sm: "9" } },
                [
                  _c(VTextField, {
                    attrs: {
                      id: "nome",
                      color: "primary",
                      label: "Nome",
                      "prepend-icon": "library_books",
                      required: "",
                      disabled: "",
                    },
                    model: {
                      value: _vm.mapeamento.nome,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.mapeamento,
                          "nome",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "mapeamento.nome",
                    },
                  }),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "12", sm: "3" } },
                [
                  _c("app-year-select", {
                    attrs: {
                      rules: [
                        (v) => v >= _vm.anoAtual || "Selecione um ano atual",
                      ],
                      desabilitado: _vm.isEdicaoBloqueada,
                    },
                    model: {
                      value: _vm.mapeamento.ano,
                      callback: function ($$v) {
                        _vm.$set(_vm.mapeamento, "ano", $$v)
                      },
                      expression: "mapeamento.ano",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            [
              _vm.mapeamento.inicioPerComportServidor !== null
                ? _c(
                    VCol,
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c(
                        VCard,
                        { attrs: { flat: "", outlined: "" } },
                        [
                          _c(
                            VCardTitle,
                            { staticClass: "subtitle-1 primary--text" },
                            [_vm._v(" Cadastro dos Comportamentos ")]
                          ),
                          _c(
                            VCardText,
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "12", sm: "6" } },
                                    [
                                      _c("app-date-select", {
                                        attrs: {
                                          label: "Data Inicial",
                                          tooltip:
                                            "Data inicial para cadastrar os comportamentos",
                                          "data-inicial":
                                            _vm.mapeamento
                                              .inicioPerComportServidor,
                                          rules: [
                                            ..._vm.rulesDataInicial,
                                            ..._vm.rulesMinDataDiagnostico,
                                          ],
                                          min: _vm.minInicioPerComportServidor,
                                          max: _vm.maxInicioPerComportServidor,
                                          desabilitado: _vm.isDataDesabilitada(
                                            _vm.mapeamento
                                              .inicioPerComportServidor
                                          ),
                                        },
                                        on: {
                                          return: (value) =>
                                            (_vm.mapeamento.inicioPerComportServidor =
                                              value),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { attrs: { cols: "12", sm: "6" } },
                                    [
                                      _c("app-date-select", {
                                        attrs: {
                                          label: "Data Final",
                                          tooltip:
                                            "Data final para cadastrar os comportamentos",
                                          "data-inicial":
                                            _vm.mapeamento
                                              .fimPerComportServidor,
                                          rules: [
                                            ..._vm.rulesDataFinal,
                                            ..._vm.rulesMinDataDiagnostico,
                                          ],
                                          min: _vm.minFimPerComportServidor,
                                          max: _vm.maxFimPerComportServidor,
                                          desabilitado:
                                            _vm.mapeamento
                                              .inicioPerComportServidor ===
                                              "" ||
                                            _vm.isDataDesabilitada(
                                              _vm.mapeamento
                                                .fimPerComportServidor
                                            ),
                                        },
                                        on: {
                                          return: (value) =>
                                            (_vm.mapeamento.fimPerComportServidor =
                                              value),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                VCol,
                { attrs: { cols: "12", md: "6" } },
                [
                  _c(
                    VCard,
                    { attrs: { flat: "", outlined: "" } },
                    [
                      _c(
                        VCardTitle,
                        { staticClass: "subtitle-1 primary--text" },
                        [_vm._v(" Normalização dos Comportamentos ")]
                      ),
                      _c(
                        VCardText,
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("app-date-select", {
                                    attrs: {
                                      label: "Data Inicial",
                                      tooltip:
                                        "Data inicial para normalizar os comportamentos cadastrados",
                                      "data-inicial":
                                        _vm.mapeamento.inicioPerComportComissao,
                                      rules: [
                                        ..._vm.rulesDataInicial,
                                        ..._vm.rulesMinDataDiagnostico,
                                      ],
                                      min: _vm.minInicioPerComportComissao,
                                      max: _vm.maxInicioPerComportComissao,
                                      desabilitado:
                                        _vm.mapeamento
                                          .inicioPerComportServidor === "" ||
                                        _vm.mapeamento.fimPerComportServidor ===
                                          "" ||
                                        _vm.isDataDesabilitada(
                                          _vm.mapeamento
                                            .inicioPerComportComissao
                                        ),
                                    },
                                    on: {
                                      return: (value) =>
                                        (_vm.mapeamento.inicioPerComportComissao =
                                          value),
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("app-date-select", {
                                    attrs: {
                                      label: "Data Final",
                                      tooltip:
                                        "Data final para normalizar os comportamentos cadastrados",
                                      "data-inicial":
                                        _vm.mapeamento.fimPerComportComissao,
                                      rules: [
                                        ..._vm.rulesDataFinal,
                                        ..._vm.rulesMinDataDiagnostico,
                                      ],
                                      min: _vm.minFimPerComportComissao,
                                      max: _vm.maxFimPerComportComissao,
                                      desabilitado:
                                        _vm.mapeamento
                                          .inicioPerComportComissao === "" ||
                                        _vm.isDataDesabilitada(
                                          _vm.mapeamento.fimPerComportComissao
                                        ),
                                    },
                                    on: {
                                      return: (value) =>
                                        (_vm.mapeamento.fimPerComportComissao =
                                          value),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            [
              _c(
                VCol,
                { attrs: { cols: "12", md: "6" } },
                [
                  _c(
                    VCard,
                    { attrs: { flat: "", outlined: "" } },
                    [
                      _c(
                        VCardTitle,
                        { staticClass: "subtitle-1 primary--text" },
                        [_vm._v(" Cadastro das Responsabilidades ")]
                      ),
                      _c(
                        VCardText,
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("app-date-select", {
                                    attrs: {
                                      label: "Data Inicial",
                                      tooltip:
                                        "Data inicial para cadastrar as responsabilidades",
                                      "data-inicial":
                                        _vm.mapeamento.inicioPerRespGestor,
                                      rules: [
                                        ..._vm.rulesDataInicial,
                                        ..._vm.rulesMinDataDiagnostico,
                                      ],
                                      min: _vm.minInicioPerRespGestor,
                                      max: _vm.maxInicioPerRespGestor,
                                      desabilitado: _vm.isDataDesabilitada(
                                        _vm.mapeamento.inicioPerRespGestor
                                      ),
                                    },
                                    on: {
                                      return: (value) =>
                                        (_vm.mapeamento.inicioPerRespGestor =
                                          value),
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("app-date-select", {
                                    attrs: {
                                      label: "Data Final",
                                      tooltip:
                                        "Data final para cadastrar as responsabilidades",
                                      "data-inicial":
                                        _vm.mapeamento.fimPerRespGestor,
                                      rules: [
                                        ..._vm.rulesDataFinal,
                                        ..._vm.rulesMinDataDiagnostico,
                                      ],
                                      min: _vm.minFimPerRespGestor,
                                      max: _vm.maxFimPerRespGestor,
                                      desabilitado:
                                        _vm.mapeamento.inicioPerRespGestor ===
                                          "" ||
                                        _vm.isDataDesabilitada(
                                          _vm.mapeamento.fimPerRespGestor
                                        ),
                                    },
                                    on: {
                                      return: (value) =>
                                        (_vm.mapeamento.fimPerRespGestor =
                                          value),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "12", md: "6" } },
                [
                  _c(
                    VCard,
                    { attrs: { flat: "", outlined: "" } },
                    [
                      _c(
                        VCardTitle,
                        { staticClass: "subtitle-1 primary--text" },
                        [_vm._v(" Normalização das Responsabilidades ")]
                      ),
                      _c(
                        VCardText,
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("app-date-select", {
                                    attrs: {
                                      label: "Data Inicial",
                                      tooltip:
                                        "Data inicial para normalizar as responsabilidades",
                                      "data-inicial":
                                        _vm.mapeamento.inicioPerRespCom,
                                      rules: [
                                        ..._vm.rulesDataInicial,
                                        ..._vm.rulesMinDataDiagnostico,
                                      ],
                                      min: _vm.minInicioPerRespCom,
                                      max: _vm.maxInicioPerRespCom,
                                      desabilitado:
                                        _vm.mapeamento.inicioPerRespGestor ===
                                          "" ||
                                        _vm.mapeamento.fimPerRespGestor ===
                                          "" ||
                                        _vm.isDataDesabilitada(
                                          _vm.mapeamento.inicioPerRespCom
                                        ),
                                    },
                                    on: {
                                      return: (value) =>
                                        (_vm.mapeamento.inicioPerRespCom =
                                          value),
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("app-date-select", {
                                    attrs: {
                                      label: "Data Final",
                                      tooltip:
                                        "Data final para normalizar as responsabilidades",
                                      "data-inicial":
                                        _vm.mapeamento.fimPerRespCom,
                                      rules: [
                                        ..._vm.rulesDataFinal,
                                        ..._vm.rulesMinDataDiagnostico,
                                      ],
                                      min: _vm.minFimPerRespCom,
                                      max: _vm.maxFimPerRespCom,
                                      desabilitado:
                                        _vm.mapeamento.inicioPerRespCom ===
                                          "" ||
                                        _vm.isDataDesabilitada(
                                          _vm.mapeamento.fimPerRespCom
                                        ),
                                    },
                                    on: {
                                      return: (value) =>
                                        (_vm.mapeamento.fimPerRespCom = value),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            [
              _c(
                VCol,
                { attrs: { cols: "12", md: "6" } },
                [
                  _c(
                    VCard,
                    { attrs: { flat: "", outlined: "" } },
                    [
                      _c(
                        VCardTitle,
                        { staticClass: "subtitle-1 primary--text" },
                        [_vm._v(" Validação das Responsabilidades ")]
                      ),
                      _c(
                        VCardText,
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("app-date-select", {
                                    attrs: {
                                      label: "Data Inicial",
                                      tooltip:
                                        "Data inicial para validar as responsabilidades",
                                      "data-inicial":
                                        _vm.mapeamento
                                          .inicioPerRespChefiaSuperior,
                                      rules: [
                                        ..._vm.rulesDataInicial,
                                        ..._vm.rulesMinDataDiagnostico,
                                      ],
                                      min: _vm.minInicioPerRespChefiaSuperior,
                                      max: _vm.maxInicioPerRespChefiaSuperior,
                                      desabilitado:
                                        _vm.mapeamento.fimPerRespCom === "" ||
                                        _vm.isDataDesabilitada(
                                          _vm.mapeamento
                                            .inicioPerRespChefiaSuperior
                                        ),
                                    },
                                    on: {
                                      return: (value) =>
                                        (_vm.mapeamento.inicioPerRespChefiaSuperior =
                                          value),
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("app-date-select", {
                                    attrs: {
                                      label: "Data Final",
                                      tooltip:
                                        "Data final para validar as responsabilidades",
                                      "data-inicial":
                                        _vm.mapeamento.fimPerRespChefiaSuperior,
                                      rules: [
                                        ..._vm.rulesDataFinal,
                                        ..._vm.rulesMinDataDiagnostico,
                                      ],
                                      min: _vm.minFimPerRespChefiaSuperior,
                                      max: _vm.maxFimPerRespChefiaSuperior,
                                      desabilitado:
                                        _vm.mapeamento
                                          .inicioPerRespChefiaSuperior === "" ||
                                        _vm.isDataDesabilitada(
                                          _vm.mapeamento
                                            .fimPerRespChefiaSuperior
                                        ),
                                    },
                                    on: {
                                      return: (value) =>
                                        (_vm.mapeamento.fimPerRespChefiaSuperior =
                                          value),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "12", md: "6" } },
                [
                  _c(
                    VCard,
                    { attrs: { flat: "", outlined: "" } },
                    [
                      _c(
                        VCardTitle,
                        { staticClass: "subtitle-1 primary--text" },
                        [_vm._v(" Consolidação das Responsabilidades ")]
                      ),
                      _c(
                        VCardText,
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("app-date-select", {
                                    attrs: {
                                      label: "Data Inicial",
                                      tooltip:
                                        "Data inicial para consolidar as responsabilidades",
                                      "data-inicial":
                                        _vm.mapeamento.inicioPerRespConsol,
                                      rules: [
                                        ..._vm.rulesDataInicial,
                                        ..._vm.rulesMinDataDiagnostico,
                                      ],
                                      min: _vm.minInicioPerRespConsol,
                                      max: _vm.maxInicioPerRespConsol,
                                      desabilitado:
                                        _vm.mapeamento
                                          .inicioPerRespChefiaSuperior === "" ||
                                        _vm.mapeamento
                                          .fimPerRespChefiaSuperior === "" ||
                                        _vm.isDataDesabilitada(
                                          _vm.mapeamento.inicioPerRespConsol
                                        ),
                                    },
                                    on: {
                                      return: (value) =>
                                        (_vm.mapeamento.inicioPerRespConsol =
                                          value),
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("app-date-select", {
                                    attrs: {
                                      label: "Data Final",
                                      tooltip:
                                        "Data final para consolidar as responsabilidades",
                                      "data-inicial":
                                        _vm.mapeamento.fimPerRespConsol,
                                      rules: [
                                        ..._vm.rulesDataFinal,
                                        ..._vm.rulesMinDataDiagnostico,
                                      ],
                                      min: _vm.minFimPerRespConsol,
                                      max: _vm.maxFimPerRespConsol,
                                      desabilitado:
                                        _vm.mapeamento.inicioPerRespConsol ===
                                          "" ||
                                        _vm.isDataDesabilitada(
                                          _vm.mapeamento.fimPerRespConsol
                                        ),
                                    },
                                    on: {
                                      return: (value) =>
                                        (_vm.mapeamento.fimPerRespConsol =
                                          value),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            { staticClass: "justify-end" },
            [
              _c(
                VTooltip,
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on }) {
                          return [
                            _c(
                              VBtn,
                              _vm._g(
                                {
                                  staticClass: "mr-2",
                                  attrs: {
                                    disabled:
                                      !_vm.valid ||
                                      _vm.mapeamento.unidades.length === 0,
                                    color: "primary",
                                    type: "submit",
                                  },
                                },
                                on
                              ),
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.isEdicao ? "Editar" : "Cadastrar"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    121952457
                  ),
                },
                [
                  _c("span", [
                    _vm._v(
                      "Clique no botão para " +
                        _vm._s(_vm.isEdicao ? "editar" : "salvar") +
                        " o mapeamento"
                    ),
                  ]),
                ]
              ),
              _c(
                VTooltip,
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on }) {
                          return [
                            _c(
                              VBtn,
                              _vm._g(
                                {
                                  staticClass: "mr-3",
                                  attrs: {
                                    disabled: !_vm.formUpdated,
                                    color: "primary",
                                    outlined: "",
                                  },
                                  on: { click: _vm.reset },
                                },
                                on
                              ),
                              [_vm._v(" Cancelar ")]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2632301528
                  ),
                },
                [
                  _c("span", [
                    _vm._v(
                      "Clique no botão para cancelar " +
                        _vm._s(_vm.isEdicao ? "a edição" : "o cadastro") +
                        " do mapeamento"
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c("importacao-mapeamento", {
            attrs: {
              visibilidade: _vm.isImportacao,
              toogle: _vm.toogleDialogImportacao,
            },
            on: { import: (value) => _vm.addImportacao(value) },
          }),
          _c("dialog-info", { attrs: { value: _vm.aviso } }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }